import AdmUnit from "./admUnit";
import getNextPost from "./getNextPost";

jQuery(document).ready(() => {
  class GCMediaInfiniteScrolling {
    observer = null;
    articleContainer = jQuery(ajaxData.options.postContainerCSSSelector);
    intersectionElements = [];
    queriedPosts = [
      {
        id: ajaxData.initialPostData.ID,
        slug: ajaxData.initialPostData.post_name,
        title: ajaxData.initialPostData.post_title + " - " + ajaxData.siteTitle,
      },
    ];
    currentIndex = 0;

    constructor() {
      this.createAndAppendFirstObservableElement();
      this.createObserver();
      this.parseAppendedPostAds(
        this.articleContainer,
        ajaxData.initialPostData.ID
      );
      this.observe(this.currentIndex);
    }

    createIntersectionElement(index, postId) {
      const intersectionElement = jQuery("<div></div>");
      intersectionElement.attr("data-intersection-index", `${index}`);
      intersectionElement.attr("data-post-id", postId);
      intersectionElement.attr("class", "IntersectionElement");
      intersectionElement.css(
        "border-color",
        ajaxData.options.separatorBorderColor
      );

      this.intersectionElements.push(intersectionElement);

      return intersectionElement;
    }

    createPostElement() {
      const postElement = jQuery("<div></div>");

      const loadingIndicator = jQuery(
        "<div class='LoadingContainer'><span>Carregando...</span></div>"
      );

      loadingIndicator.css(
        "background-color",
        ajaxData.options.loadingIndicatorBGColor
      );

      postElement.append(loadingIndicator);

      return postElement;
    }

    createAndAppendFirstObservableElement() {
      const intersectionElement = this.createIntersectionElement(
        0,
        ajaxData.initialPostData.ID
      );

      const admUnit = new AdmUnit(
        `AdmUnit-0-0`,
        ajaxData.options.interstitialAdName,
        ajaxData.options.interstitialAdSizes
      );

      intersectionElement.append(admUnit.htmlElement);

      admUnit.defineAndDisplaySlot();

      this.articleContainer.after(intersectionElement);
    }

    createObserver() {
      this.observer = new IntersectionObserver(this.intersectionCallback, {
        threshold: 1,
      });
    }

    intersectionCallback([entry]) {
      const entryIndex = parseInt(entry.target.dataset.intersectionIndex);

      const postId = jQuery(entry.target).attr("data-post-id");

      instance.updateCurrentNewsIndex(entry, entryIndex);

      if (
        entry.isIntersecting &&
        entryIndex === instance.intersectionElements.length - 1
      ) {
        instance.fetchPreviousPostData(postId, (data) => {
          instance.appendPost(data, entryIndex);
        });
      }
    }

    fetchPreviousPostData(postId, cb) {
      getNextPost(postId, cb);
    }

    appendPost(data, entryIndex) {
      const intersectionElement = this.createIntersectionElement(
        entryIndex + 1,
        data.ID
      );

      const postElement = this.createPostElement(data, intersectionElement);

      this.intersectionElements[entryIndex].after(postElement);

      postElement.load(
        `${ajaxData.baseUrl}?p=${data.ID} ${ajaxData.options.postContainerCSSSelector}`,
        () => {
          intersectionElement.insertAfter(postElement);
          this.observe(entryIndex + 1);

          const admUnit = new AdmUnit(
            `AdmUnit-${entryIndex}-${data.ID}`,
            ajaxData.options.interstitialAdName,
            ajaxData.options.interstitialAdSizes
          );

          intersectionElement.append(admUnit.htmlElement);

          admUnit.defineAndDisplaySlot();

          this.parseAppendedPostAds(postElement, data.ID);

          this.queriedPosts.push({
            slug: data.post_name,
            title: data.post_title + " - " + ajaxData.siteTitle,
            id: data.ID,
          });
        }
      );
    }

    observe(index) {
      this.observer.observe(jQuery(`div[data-intersection-index=${index}]`)[0]);
    }

    updateBrowserURL() {
      const postIndex = this.currentIndex;

      const newUrl = new URL(
        `${ajaxData.baseUrl}/noticia/${this.queriedPosts[postIndex].slug}`
      );

      jQuery(document).prop("title", this.queriedPosts[postIndex].title);

      window.history.pushState({}, this.queriedPosts[postIndex].title, newUrl);
    }

    updateCurrentNewsIndex(entry, entryIndex) {
      const oldIndex = this.currentIndex;

      if (entry.boundingClientRect.top > 0) {
        this.currentIndex = entryIndex;
      }

      if (entry.boundingClientRect.top < 0) {
        this.currentIndex = entryIndex + 1;
      }

      if (oldIndex !== this.currentIndex) {
        this.updateBrowserURL(this.currentIndex);
      }
    }

    parseAppendedPostAds(postElement, postId) {
      const ads = jQuery(postElement).find(".GCMIS_Unit");

      ads.each((index, ad) => {
        const admUnit = new AdmUnit(
          `AdmUnit-parsed-${index}-${postId}`,
          jQuery(ad).data("adm-name"),
          jQuery(ad).data("adm-sizes")
        );

        jQuery(ad).append(admUnit.htmlElement);

        admUnit.defineAndDisplaySlot();
      });
    }
  }

  const instance = new GCMediaInfiniteScrolling();
});
